module.exports = __webpack_public_path__ + "img/business-consulting-2-light.057bcc67.png";